.root {
  --radio-size: 16px;

  &[data-checked='true'] {
    label {
      color: red;
    }
  }
}

.label {
  padding-left: 6px;
}

.body {
  display: flex;
  align-items: center;
}
